//Author June Leow
//Date Mar 25th, 2024
import {generateTooltip} from '../../../../util/util';
import React, {useEffect} from 'react';
import {Card, CardHeader, CardBody, Col, Row, Label, FormGroup, Input} from 'reactstrap';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import MySelect from '../../../util/my-select';
import Signature from '../../signature';

const contactMethodEnum = [{value:'PHONE',label:'Phone'},{value:'EMAIL',label:'Email'}];
const collectorTypeEnum = [{value:'APPRAISER',label:'Appraiser'},{value:'APPRAISER_TRAINEE',label:'Appraiser Trainee'},{value:'INSURANCE_INSPECTOR',label:'Insurance Inspector'},{value:'REAL_ESTATE_AGENT',label:'Real Estate Agent'},{value:'NOTARY_PUBLIC',label:'Public Notary'},{value:'SMART_HOME_SERVICES',label:'Smart Home Services'},{value:'PHOTOGRAPHER',label:'Photographer'},{value:'PROPERTY_PRESERVATION_AGENT',label:'Property Preservation Agent'},{value:'HOME_INSPECTOR',label:'Home Inspector'},{value:'HOMEOWNER',label:'Home Owner'},{value:'OTHER',label:'Other'}];
const disabledStyling = {border:'none', background:'#fff', padding:'0',paddingLeft:'2px', height:'auto',WebkitAppearance:'none'};

const StepCertification  = (props)=>{
  const controller = new AbortController();

  //run only once when component is loaded
  useEffect(()=>{
    return ()=> controller.abort();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  //non API call but simpyl manage state
  const updateField = (field, value)=>{
    let newUPD = Object.assign({}, props.upd);
    switch(field){
      
      case 'signature':
        newUPD.signature = value;
        break;
      case 'comment':
        newUPD.comment = value;
        break;
      case 'propertyDataCollectorName':
        newUPD.propertyDataCollectorName = value;
        break;
      case 'dataCollectionDate':
        newUPD.dataCollectionDate = value;
        break;
      case 'dateOfSignatureReport':
        newUPD.dateOfSignatureReport = value;
        break;
      case 'dataCollectorAcknowledgement':
        newUPD.dataCollectorAcknowledgement = value;
        break;
      case 'contactMethod':
        newUPD.propertyDataCollectorContacts.contactMethod = value;
        break;
      case 'contactDetail':
        newUPD.propertyDataCollectorContacts.contactDetail = value;
        break;
      case 'contactMethod2':
        newUPD.propertyDataCollectorContacts.contactMethod2 = value;
        break;
      case 'contactDetail2':
        newUPD.propertyDataCollectorContacts.contactDetail2 = value;
        break;
      case 'pdaCollectionEntity':
        newUPD.pdaCollectionEntity = value;
        break;
      case 'propertyDataCollectorType':
        newUPD.propertyDataCollectorType = value;
        break;
      case 'propertyDataCollectorTypeDescription':
        newUPD.propertyDataCollectorTypeDescription = value;
        break;
      default:
        break;
    }
    props.update(newUPD);
  }

  //API call

  //render
  let signature = <div style={{width:'100%',minHeight:'200px',maxHeight:'200px',background:'white'}}>&nbsp;</div>;

  if(props.disabled){
    if(props.upd.signature.draw && props.upd.signature.draw!==''){
      signature = <img alt="pic" width="100%" height="200" src={'data:image/png;base64, '+props.upd.signature.draw}/>
    }
    else if(props.upd.signature.upload && props.upd.signature.upload!==''){
      signature = <img alt="pic" width="100%" height="200" src={'data:image/png;base64, '+props.upd.signature.upload}/>
    }
  }
  else{
    signature = <Signature update={(type, base64)=>updateField('signature',Object.assign({}, props.upd.signature, {[type]:base64}))}/>;
  }
  

  let dataCollectionDate;
  if(props.upd.dataCollectionDate!==''&&props.upd.dataCollectionDate!=='0000-00-00')
    dataCollectionDate = moment(props.upd.dataCollectionDate).toDate();

  let dateOfSignatureReport;
  if(props.upd.dateOfSignatureReport!==''&&props.upd.dateOfSignatureReport!=='0000-00-00')
  dateOfSignatureReport = moment(props.upd.dateOfSignatureReport).toDate();

  let propertyDataCollectorTypeDescription;

  if(props.upd.propertyDataCollectorType==='OTHER'){
    propertyDataCollectorTypeDescription = <Col sm="3">
    <label>{!props.disabled?<font color="red">*</font>:null}Property Data Collector Description {generateTooltip('propertyDataCollectorTypeDescription', 'What is the Other Property Data Collector Type')}</label>
    <Input style={props.disabled?disabledStyling:{}} disabled={props.disabled} required={!props.disabled} type="text" value={props.upd.propertyDataCollectorTypeDescription} onChange={(e)=>updateField('propertyDataCollectorTypeDescription', e.target.value)}/>
  </Col>
  }
  return <div>
    <br/>
    <Card>
      <CardHeader className="header-color">
        Property Data Collector Information
      </CardHeader>
      <CardBody>
        
        <Row style={{marginTop:'15px'}}>
          <Col sm="3">
            <label>{!props.disabled?<font color="red">*</font>:null}Property Data Collector Name {generateTooltip('propertyDataCollectorName', 'Name of the individual who conducted the property data collection.')}</label>
            <Input style={props.disabled?disabledStyling:{}} disabled={props.disabled} required={!props.disabled} type="text" value={props.upd.propertyDataCollectorName} onChange={(e)=>updateField('propertyDataCollectorName', e.target.value)}/>
          </Col>
          <Col sm="3">
            <label>{!props.disabled?<font color="red">*</font>:null}Property Data Collector Company {generateTooltip('pdaCollectionEntity', 'Company name of the entity that performed the property data collection.')}</label>
            <Input style={props.disabled?disabledStyling:{}} disabled={props.disabled} required={!props.disabled} type="text" value={props.upd.pdaCollectionEntity} onChange={(e)=>updateField('pdaCollectionEntity', e.target.value)}/>
          </Col>
          <Col sm="3">
            <label>{!props.disabled?<font color="red">*</font>:null}Property Data Collector Type {generateTooltip('propertyDataCollectorType', 'Name of the labor force type of the individual who conducted the property data collection.')}</label>
            <MySelect
              type="select"
              required={!props.disabled}
              disabled={props.disabled}
              style={props.disabled?disabledStyling:{}}
              value={props.upd.propertyDataCollectorType}
              onChange={(v)=>updateField('propertyDataCollectorType', v)}
              options={collectorTypeEnum}
            />
          </Col>
          {propertyDataCollectorTypeDescription}
        </Row>
        <Row>
          <Col sm="3">
            <label>{!props.disabled?<font color="red">*</font>:null}Property Data Collector Contact Method {generateTooltip('contactMethod', 'Contact information for the individual performing the property data collection.')}</label>
            <MySelect
              type="select"
              required={!props.disabled}
              disabled={props.disabled}
              style={props.disabled?disabledStyling:{}}
              value={props.upd.propertyDataCollectorContacts.contactMethod}
              onChange={(v)=>updateField('contactMethod', v)}
              options={contactMethodEnum}
            />
          </Col>
          <Col sm="3">
            <label>{!props.disabled?<font color="red">*</font>:null}Property Data Collector Contact {generateTooltip('contactDetail', 'Contact information for the individual performing the property data collection, i.e. the email address or phone number.')}</label>
            <Input style={props.disabled?disabledStyling:{}} disabled={props.disabled} required={!props.disabled} type="text" value={props.upd.propertyDataCollectorContacts.contactDetail} onChange={(e)=>updateField('contactDetail', e.target.value)}/>
          </Col>
        </Row>

        <Row>
          <Col sm="3">
            <label>Additional Property Data Collector Contact Method {generateTooltip('contactMethod2', 'Contact information for the individual performing the property data collection.')}</label>
            <MySelect
              type="select"
              required={false}
              disabled={props.disabled}
              style={props.disabled?disabledStyling:{}}
              value={props.upd.propertyDataCollectorContacts.contactMethod2}
              onChange={(v)=>updateField('contactMethod2', v)}
              options={contactMethodEnum}
            />
          </Col>
          <Col sm="3">
            <label>{!props.disabled?<font color="red">*</font>:null}Property Data Collector Contact {generateTooltip('contactDetail2', 'Contact information for the individual performing the property data collection, i.e. the email address or phone number.')}</label>
            <Input style={props.disabled?disabledStyling:{}} disabled={props.disabled} required={false} type="text" value={props.upd.propertyDataCollectorContacts.contactDetail2} onChange={(e)=>updateField('contactDetail2', e.target.value)}/>
          </Col>
        </Row>

        <br/>
        <Row style={{marginTop:'15px'}}>
          <Col sm="4">
            <label><font color="red">*</font>Date of Observation</label><br/>
            <DatePicker style={props.disabled?disabledStyling:{}} disabled={props.disabled}
              className="form-control"
              dateFormat="yyyy-MM-dd"
              selected={dataCollectionDate}
              onChange={(text)=>{if(text){
                text = moment(text).format("yyyy-MM-DD");
                updateField('dataCollectionDate',text)
              }}}
            />
          </Col>
          <Col sm="4">
            <label><font color="red">*</font>Date of signature & report</label><br/>
            <DatePicker style={props.disabled?disabledStyling:{}} disabled={props.disabled}
              className="form-control"
              dateFormat="yyyy-MM-dd"
              selected={dateOfSignatureReport}
              onChange={(text)=>{if(text){
                text = moment(text).format("yyyy-MM-DD");
                updateField('dateOfSignatureReport',text)
              }}}
            />
          </Col>
        </Row>
        <br/><br/>
          <label>Comment On Report</label><br/>
          <Input type="textarea" value={props.upd.comment} onChange={(e)=>updateField('comment', e.target.value)}/>
        <br/>
        {signature}
        <br/><br/>
        {props.disabled?null:<div className="display-inline" style={{verticalAlign:'top'}}>
          <FormGroup check>
            <Label check>
              <Input required={true} type="checkbox" value={props.upd.dataCollectorAcknowledgement} onChange={(e)=>updateField('dataCollectorAcknowledgement',e.target.checked)}/>
            </Label>
          </FormGroup>
        </div>}
        <div className="display-inline" style={{verticalAlign:'top', fontSize:'12px'}}>
          <b>STATEMENT OF LIMITING CONDITIONS</b>
        </div>
        <div style={{fontSize:'12px'}}>
          CONTINGENT AND LIMITING CONDITIONS: The data collector's certification that appears in this report is subject to the following conditions:<br/>
          1.  I will not be responsible for reporting matters of a legal nature that affect either the subject property or its title.<br/>
          2.  I attest that all data I collected and communicated to the vendor (or lender) is reliable and accurate. <br/>
          3.  I will not be required to give testimony or appear in court because of this assignment unless specific arrangements to do so were made beforehand, or as otherwise required by law.<br/>
          4.  I have communicated to the vendor (or lender) any observed adverse conditions (such as, but not limited to, needed repairs, the presence of hazardous wastes, toxic substances, pest infestation, structural problems, mechanical problems, or habitability issues). I make no guarantees or warranties, expressed or implied, regarding any unobserved conditions. Furthermore, because I am not an expert in the field of environmental hazards, pests, structural integrity or mechanical systems, this assignment must not be considered as an environmental assessment, pest inspection, home inspection report or engineering report.<br/>
          5.  I will not disclose the contents of this assignment to any individual or party other than the client, lender or vendor, except as required by law or as directed by the client. <br/>
        </div>
        <br/>
        <div className="display-inline" style={{verticalAlign:'top', fontSize:'12px'}}>
          <b>SCOPE OF WORK</b>
        </div>
        <div style={{fontSize:'12px'}}>
          1.  The scope of work for this assignment is to collect and communicate to the vendor (or lender) observations of the subject property and its relevant characteristics. <br/>
        </div>
        <br/>
        <div className="display-inline" style={{verticalAlign:'top', fontSize:'12px'}}>
          <b>DATA COLLECTOR\'S CERTIFICATION</b><br/>I certify that, to the best of my knowledge and belief:
        </div>
        <br/>
        <div className="large-scroll-container" style={{fontSize:'12px'}}>
          1.  I have no present or prospective interest in the property that is the subject of this report, and no relationship with the present or prospective owners or occupants of the subject property or any other party involved in the transaction.<br/>
          2.  I am aware of and have complied with all applicable laws and regulations, including antidiscrimination laws, rules, and requirements that apply to me or to the assignment.<br/>
          3.  I have performed this assignment without bias with respect to the parties involved in the transaction, the property that is the subject of this report, or the demographics of the area where the property is located.<br/>
          4.  I did not base any part of this report on the actual or perceived race, color, religion, sex (including sexual orientation or gender identity), age (other than as applicable for legally age-restricted communities), marital status, disability, familial status, or national origin of the present or prospective owners or occupants of either the subject property or properties in the area of the subject property or on any other basis prohibited by the Fair Housing Act or the Equal Credit Opportunity Act, or any other basis prohibited by law.<br/>
          5.  The data I collected and communicated to the vendor (or lender) does not contain intentional or negligent misrepresentation(s). <br/>
          6.  The data I collected and communicated to the vendor (or lender) represents a complete visual data collection of the interior and exterior areas of the subject property. It represents the property characteristics in factual, specific terms and includes any known physical deficiencies that could affect the soundness or structural integrity of the property.<br/>
          7.  My compensation is not contingent on any action or event resulting from the opinions, conclusions, or use of this data.<br/>
          8.  I have adequate knowledge and training to collect and report data for this assignment.<br/>
          9.  My employment and/or compensation for this or any future assignments was not conditioned on any agreement or understanding, written or otherwise, that I would collect and report a predetermined specific outcome that favors the cause of any party, or the attainment of a specific result or the occurrence of a specific subsequent event (such as approval of a pending mortgage loan application.)<br/>
          10. I am aware that any disclosure or distribution of this property data report or any of its contents by me or the lender/client may be subject to certain laws and regulations.<br/>
          11. The lender/client may disclose or distribute this property data report to: the borrower; another lender at the request of the borrower; the mortgagee or its successors and assigns; mortgage insurers; government sponsored enterprises; other secondary market participants; data collection or reporting services; any department, agency, or instrumentality of the United States; or any state, the District of Columbia, or other jurisdictions. Any of the foregoing persons or entities who receives this property data report may choose to store, copy, reproduce, analyze, use or distribute the data in the property data report for internal or external purposes without having to obtain my consent. My consent must be obtained before this property data report may be disclosed or distributed to any other party (including, but not limited to, the public through advertising, public relations, news, sales, or other media). <br/>
          12. If the data collected was transmitted as an “electronic record” containing my “electronic signature,” as those terms are defined in applicable federal and/or state laws (excluding audio and video recordings), or as a facsimile transmission containing a copy or representation of my signature, it shall be as effective, enforceable and valid as if a paper version of the data containing my original hand-written signature were delivered.
        </div>
      </CardBody>
    </Card>
  </div>
}


export default StepCertification;